module.exports = __webpack_public_path__ + "img/cast_about_banner.96e637a7.png";